import React, {Component} from 'react';

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import compose from 'recompose/compose';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';

import {
  initStackup,
  clearStartNewForm,
  saveStackup
} from '../../../actions';
import { newStackup } from '../../../lib/stackup';
import { stackupPropType } from '../../../lib/shapes';
import { getStackup } from '../../../reducers';
import StartNewForm from './StartNewForm';
import FormFrame from '../../common/FormFrame';

export class StartNew extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
  }

  handleSubmit(event, data) {
    const { history, initStackup, saveStackup } = this.props;
    const stackup = newStackup(data);

    initStackup(stackup);
    clearStartNewForm();
    saveStackup();
    history.push('/app');
  }

  handleCancel() {
    const { clearStartNewForm, history } = this.props;
    clearStartNewForm();

    history.push('/app');
  }

  didcomponentDidMount(props) {
    const { clearStartNewForm } = props;
    clearStartNewForm();
  }

  render () {
    const { stackup } = this.props;
    const onCancel = !isEmpty(stackup) ? this.handleCancel : undefined;

    return (
      <FormFrame
        label="New Stackup"
        description="Please provide following information to start a new project."
      >
        <StartNewForm
          onSubmit={this.handleSubmit}
          onCancel={onCancel}
        />
      </FormFrame>
    );
  }
}

function mapStateToProps(state){
  return {
    stackup: getStackup(state),
  }
}

const mapStateToDispatch = {
  initStackup,
  clearStartNewForm,
  saveStackup,
}


StartNew.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  initStackup: PropTypes.func.isRequired,
  saveStackup: PropTypes.func.isRequired,
  clearStartNewForm: PropTypes.func.isRequired,
  stackup: PropTypes.shape(stackupPropType)
};

StartNew.defaultProps = {
  stackup: undefined
}

export default compose(
  withRouter,
  connect(mapStateToProps, mapStateToDispatch)
)(StartNew);



// WEBPACK FOOTER //
// ./src/components/StackupDesign/StartNew/index.js